import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    maderaLoaderWrapper: {
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
    loaderCircle: {
        animationDuration: "1s",
        animationIterationCount: "infinite",
        animationName: "$circleTransition",
        transformOrigin: "center center",
    },
    loaderPath: {
        animationDuration: "1s",
        animationIterationCount: "infinite",
        animationName: "$fadeTransition",
        transformOrigin: "center center",
    },
    "@keyframes circleTransition": {
        from: {
            transform: "scale(0)",
        },
        to: {
            transform: "scale(1)",
        },
    },
    "@keyframes fadeTransition": {
        from: {
            opacity: "0",
        },
        to: {
            opacity: "1",
        },
    },
}));
